import { Facebook, Linkedin, MessageCircle, Twitter, Youtube } from "lucide-react";

import { useTranslation } from "react-i18next";
import { LanguageSelector } from "../ui/languageSelector";
import { useNavigateWithScroll } from "../../hooks/useNavigateWithScroll";
import logo from "../../assets/icon.png"

export const Footer: React.FC = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigateWithScroll()

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid md:grid-cols-4 gap-8">
                    <div className="col-span-2">
                        <button onClick={() => { navigate("/") }} className="flex items-center mb-4 hover:text-purple-400 transition-colors">
                            {/* <MessageCircle className="w-8 h-8 text-purple-400" /> */}
                            <img src={logo} width={35} alt="" />
                            <span className="ml-2 text-xl font-bold">3wChat</span>
                        </button>
                        <p className="text-gray-400 mb-6 max-w-md">
                            {t('footer.description')}
                        </p>
                        <div className="flex space-x-4">
                            <button className="text-gray-400 hover:text-purple-400 transition-colors">
                                <Facebook className="w-6 h-6" />
                            </button>
                            <button className="text-gray-400 hover:text-purple-400 transition-colors">
                                <Twitter className="w-6 h-6" />
                            </button>
                            <button className="text-gray-400 hover:text-purple-400 transition-colors">
                                <Linkedin className="w-6 h-6" />
                            </button>
                            <button className="text-gray-400 hover:text-purple-400 transition-colors">
                                <Youtube className="w-6 h-6" />
                            </button>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">{t('footer.links.product')}</h3>
                        <ul className="space-y-2">
                            <li><button onClick={() => { navigate("/individual") }} className="text-gray-400 hover:text-white transition-colors">3wChat Individual</button></li>
                            <li><button onClick={() => { navigate("/business") }} className="text-gray-400 hover:text-white transition-colors">3wChat Business</button></li>
                            <li><button onClick={() => { navigate("/features") }} className="text-gray-400 hover:text-white transition-colors">Fonctionnalités</button></li>
                            <li><button onClick={() => { navigate("/pricing") }} className="text-gray-400 hover:text-white transition-colors">Tarifs</button></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">{t('footer.links.support')}</h3>
                        <ul className="space-y-2">
                            <li><button className="text-gray-400 hover:text-white transition-colors">Documentation</button></li>
                            <li><button className="text-gray-400 hover:text-white transition-colors">API</button></li>
                            <li><button onClick={() => { navigate("/contact") }} className="text-gray-400 hover:text-white transition-colors">Support</button></li>
                            <li><button className="text-gray-400 hover:text-white transition-colors">FAQ</button></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-400 text-sm">
                        © 2025 3wChat. Tous droits réservés.
                    </p>
                    {/* <LanguageSelector /> */}
                </div>
            </div>
        </footer>
    );
};